<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input clearable v-model="tableParams.username" placeholder="请输入姓名/手机号"></el-input>
        </el-form-item>

        <el-form-item label="状态" label-width="40px">
          <el-select clearable v-model="tableParams.userStatus" placeholder="请选择状态">
            <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" label-width="70px">
          <el-select clearable v-model="tableParams.auditStatus" placeholder="请选择审核状态">
            <el-option v-for="item in auditList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账户类型" label-width="70px">
          <el-select clearable v-model="tableParams.userType" placeholder="请选择账户类型">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-plus" class="search_area_btn" @click="goAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="tree_table">
      <div class="tree_box">
        <div style="margin-bottom: 20px">
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" clearable></el-input>
        </div>
        <el-tree :data="treeData" ref="tree" show-checkbox node-key="id" :props="defaultProps" @check="treeChange"
          v-loading="treeLoading" :filter-node-method="filterNode" :default-expand-all="true"></el-tree>
      </div>
      <div class="table_box">
        <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
          v-loading="tableLoading">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="username" label="姓名"> </el-table-column>
          <el-table-column property="sex" label="性别">
            <template slot-scope="scope">
              <div>{{ scope.row.sex == 0 ? "女" : (scope.row.sex == 1 ? "男" : '未知') }}</div>
            </template>
          </el-table-column>
          <el-table-column property="phoneNumber" label="手机号" width="120">
          </el-table-column>
          <el-table-column property="roleNameList" label="角色名称" width="150">
          </el-table-column>
          <el-table-column property="userStatus" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.userStatus" :active-value="0" :inactive-value="1" active-color="#7490EB"
                inactive-color="#E7E7E7"
                :disabled="scope.row.userId == 'sys_admin' || scope.row.auditStatus == 1 ? true : false"
                @change="switchChange($event, scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column property="auditStatusDesc" label="审核状态">
          </el-table-column>
          <el-table-column property="userType" label="账户类型">
          </el-table-column>
          <el-table-column property="remark" label="备注"> </el-table-column>
          <el-table-column property="createTime" label="创建时间" width="160">
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goRedact(scope.row)" v-if="scope.row.userId != 'sys_admin'">修改</el-button>
              <el-button type="text" @click="getDetele(scope.row)" v-if="scope.row.userId != 'sys_admin'">删除</el-button>
              <el-button type="text" @click="goAudit(scope.row)"
                v-if="scope.row.userId != 'sys_admin' && scope.row.auditStatus == 1">审核</el-button>
              <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="paging_box">
          <!--  :current-page="currentPage4" -->
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <v-addRedactUserAdmin :show.sync="addRedactShow" :data="addRedactData" :type="addRedactType"></v-addRedactUserAdmin>
    <v-detailUserAdmin :show.sync="detailShow" :data="detailData"></v-detailUserAdmin>
    <v-audit :show.sync="auditShow" :data="auditData"></v-audit>
  </div>
</template>

<script>
import addRedactUserAdmin from "./component/addRedactUserAdmin.vue";
import detailUserAdmin from "./component/detailUserAdmin.vue";
import audit from "./component/user_Audit.vue";
export default {
  name: "",
  data () {
    return {
      addRedactShow: false,
      detailShow: false,
      detailData: null,
      addRedactData: null,
      addRedactType: 0,
      tableData: [],
      treeData: [],
      tableParams: {
        page: 1,
        limit: 10,
        userId: "", // 登录账号(不传默认本账号)
        username: "", // 用户名,
        pid: "", // 父级账号
        userStatus: null,
        isTree: false,
        userIdFind: "",
        userType: null,
      },
      filterText: "",
      total: 0,
      tableLoading: false,
      treeLoading: false,
      stateList: [
        {
          label: "启用",
          value: 0,
        },
        {
          label: "禁用",
          value: 1,
        },
      ],
      auditList: [{
        label: "审核通过",
        value: 0,
      },
      {
        label: "审核未通过",
        value: 1,
      },],
      typeList: [
        {
          label: "企业",
          value: "企业",
        },
        {
          label: "部门主管",
          value: "部门主管",
        },
        {
          label: "个人",
          value: "个人",
        },
      ],
      activeName: "1",
      form: {},
      rules: {},
      auditShow: false,
      auditData: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  components: {
    "v-addRedactUserAdmin": addRedactUserAdmin,
    "v-detailUserAdmin": detailUserAdmin,
    "v-audit": audit,
  },
  props: {},
  created () {
    this.getList();
    this.getTree();
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getDetele (row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调接口
          this.$http.deleteUsers({ userIds: row.userId }).then((res) => {
            if (res.code === 0) {
              this.getList();
              this.getTree();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    goAudit (row) {
      this.auditShow = true;
      this.auditData = row;
    },
    goDetail (row) {
      this.detailShow = true;
      this.detailData = row;
    },
    switchChange (e, val) {
      console.log(e);
      console.log(val);
      this.$http.queryUser({ userId: val.userId }).then(ret => {
        if (ret.code === 0) {
          let password = ret.data.password;
          let roleList = ret.data.roleList
          this.$http.updateUser({
            "userStatus": e,
            "userId": val.userId,
            // "pid": val.pid,
            // "username": val.username,
            // "phoneNumber": val.phoneNumber,
            // "password": password,
            // "userType": val.userType,
            // "roleList": roleList[0].roleId
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      })

    },
    getList () {
      this.tableParams.isTree = false;
      this.tableLoading = true;
      this.$http.queryUserList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    getTree () {
      this.treeLoading = true;
      let params = {
        page: 1,
        limit: 10000000,
        userId: "", // 登录账号(不传默认本账号)
        username: "", // 用户名,
        pid: "", // 父级账号
        userStatus: null,
        isTree: true,
        userIdFind: "",
      };
      this.$http.queryUserList(params).then((res) => {
        this.treeLoading = false;
        if (res.code === 0) {
          this.treeData = res.data;
        } else {
          this.treeData = [];
        }
      });
    },
    goAdd () {
      this.addRedactShow = true;
      this.addRedactData = null;
      this.addRedactType = 0;
    },
    goRedact (row) {
      this.addRedactShow = true;
      this.addRedactData = row;
      this.addRedactType = 1;
    },
    onSubmit () {
      this.getList();
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    handleSelectionChange (e) {
      console.log(e);
    },
    handleClick (e) {
      console.log("ee", e);
    },
    treeChange () {
      this.tableParams.userIdFind = "";
      let arr = this.$refs.tree.getCheckedKeys();
      for (let i in arr) {
        this.tableParams.userIdFind +=
          i == arr.length - 1 ? arr[i] : arr[i] + ",";
      }
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";

.tree_table {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .tree_box {
    width: 240px;
    height: calc(100vh - 252px);
    border-right: 2px solid #f5f7fa;
    overflow: auto;

    /deep/.el-tree-node>.el-tree-node__children {
      overflow: visible;
    }
  }

  .table_box {
    width: calc(100% - 250px);

    .table_btns {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/user_Admin.vue